import { Injectable } from '@angular/core';
import { BaseHttpApiService } from './base-http.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Assets } from '../Dtos/assets-enum';

@Injectable({
  providedIn: 'root'
})
export class GeneralDataService extends BaseHttpApiService {

  constructor(private httpClient: HttpClient) { super();}

  public GetBMUs(asset: Assets):Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.apiURL}GeneralData/BMU/${asset}`);
  }
}
